import React from "react";
import { Button } from "@chakra-ui/react";

export const CancelButton = ({ onClose }) => {
  return (
    <Button mt="4rem" w="7rem" size="sm" onClick={onClose}>
      Cancel
    </Button>
  );
};
